import { Injectable } from '@angular/core';
import { startOfToday, addDays, isWeekend, isValid } from "date-fns";
import { isDate } from "util";

@Injectable()
export class DateService {
    public getDateAfterXDays = (numberOfDays: number): Date => {        
      return addDays(startOfToday(), numberOfDays);
    }

    public getDateAfterXWeekdays = (numberOfWeekdays: number): Date => {        
        let today = startOfToday();
        var currentDay = today;
        var weekdayCount = 0;
        var dayCount = 0;
    
        while(weekdayCount < numberOfWeekdays) {
          currentDay = addDays(currentDay, 1); 
          dayCount++;
          if(!isWeekend(currentDay)) {
            weekdayCount++;
          }
        }
    
        return addDays(today, dayCount);
    }

    public dateIsValid = (date: Date): boolean => {
        return (date && isDate(date) && isValid(date));
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/date.service.ts